var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("You are[ "+_vm._s(_vm.getTestState)+" ] s ["+_vm._s(_vm.getUserData)+"] + in home.")])])}
var staticRenderFns = []

export { render, staticRenderFns }